import { CSSObject } from "@emotion/react";

export const activeClientInfoStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>;
} => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    backgroundColor: "#F6F6F6",
    // background: "red",
    borderRadius: 8,
    height: 50,
    justifyContent: "space-between",
    margin: "8px",
    border: "none",
    cursor: "pointer",
  },
  container: {
    borderRadius: "8px",
    background: "#fff",
  },
  innerContainer: {
    background: "#fff",
    // background: "red",
    width: "90%",
    padding: 30,
  },
  iconWrapper: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    width: "90%",
    // backgroundColor: "#F6F6F6",
    // background: "red",
    borderRadius: 8,
    minHeight: 50,
    gap: 10,
    justifyContent: "space-between",
    // margin: "8px",
    border: "none",
    cursor: "pointer",
    marginBottom: 10,
    padding: "10px 20px ",
  },
  buttonContainer: {
    minWidth: "140px",
    flexShrink: 0,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    padding: "0px",
  },

  labelCell: {
    padding: "10px 15px",
    fontWeight: "bold",
    color: "#777",
    minWidth: "30%",
    fontFamily: "Gilroy-Regular",
    fontSize: 16,
    textAlign: "left",
    verticalAlign: "middle",
  },
  valueCell: {
    width: "70%",
    padding: "10px 15px",
    color: "#333",
    fontFamily: "Gilroy-Regular",
    fontSize: 16,
    fontWeight: 400,
    textAlign: "left",
    verticalAlign: "middle",
  },
  qrWrapper: {
    display: "flex",
    justifyContent: "center",
    marginTop: 20,
  },
  mainCollabseContainer: {
    marginBottom: 16,
    border: "1px solid #ddd",
    alignItems: "center",
    alignContent: "center",
    borderRadius: 8,

    width: "90%",
  },
  headerText: {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: "Gilroy-SemiBold",
    // wordBreak: "break-all",
  },
  firstCollabseContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    fontWeight: "bold",
    padding: "8px 16px",
    marginBottom: 8,
    borderRadius: 8,
    width: "90%",
  },
  secondaryCollabseContainer: {
    alignItems: "center",
    padding: "8px",
    marginBottom: 8,
    background: "#FFF",
    width: "90%",
  },
  connectionActiveStatus: {
    background: "#F0FDF4",
    color: "#00A63E",
    borderRadius: "4px",
    fontSize: 12,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "left",
    display: "inline-block",
    marginLeft: 10,
    fontFamily: "Gilroy-Regular",
  },
  connectionInActiveStatus: {
    background: "#F9FAFB",
    color: "#6A7282",
    borderRadius: "4px",
    fontSize: 12,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "left",
    display: "inline-block",
    marginLeft: 10,
    fontFamily: "Gilroy-Regular",
  },
  connectionDisconnectedStatus: {
    background: "#FFF1E3",
    color: "#913035",
    borderRadius: "4px",
    fontSize: 12,
    padding: "5px 10px",
    border: "1px solid #ddd",
    textAlign: "left",
    display: "inline-block",
    marginLeft: 10,
    fontFamily: "Gilroy-Regular",
  },
  collabseMainTitle: {
    fontFamily: "Gilroy-Regular",
    fontSize: 16,
    fontWeight: "bold",
    color: "#000000",
    wordBreak: "break-all",
  },
  collabseMainSubTitle: {
    fontFamily: "Gilroy-Regular",
    fontSize: 14,
    fontWeight: "bold",
    color: "#6B7A8F",
    marginLeft: "auto",
    wordBreak: "break-all",
  },
  collabseSubTitle: {
    fontFamily: "Gilroy-Regular",
    fontSize: 14,
    fontWeight: "bold",
    color: "#000000",
    wordBreak: "break-all",
  },
  accountCardMainTitle: {
    fontFamily: "Gilroy-Regular",
    fontSize: 14,
    fontWeight: "bold",
    color: "#000000",
    wordBreak: "break-all",
  },
  accountCardSubTitle: {
    fontFamily: "Gilroy-Regular",
    fontSize: 14,
    fontWeight: "normal",
    color: "#6B7A8F",
    wordBreak: "break-all",
  },
  accountCardSubTitleValue: {
    fontFamily: "Gilroy-Regular",
    fontSize: 14,
    fontWeight: "normal",
    color: "#000",
  },
});
// dynamic row style
export const rowStyle = (index: number): CSSObject => ({
  backgroundColor: index % 2 === 1 ? "#fff" : "#F6F6F6",
});

export const tableWrapperStyle = (selectedTab: string): CSSObject => ({
  padding: selectedTab === "personal_information" ? "10px 20px" : 0,
  minWidth: "50px",
  display: "flex",
  flexDirection: "row",
});
